
  <div class="canales">
    <div class="canal" *ngFor="let channel of channels">
      <img [src]="channel.icon" />
      <div class="nro-canal">{{channel.number}}</div>
    </div>
  </div>
